import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, LOCALE_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDistanceToNow } from 'date-fns';
import { ItemToSell } from 'src/app/_services';
import { Chat, ChatMessage, ChatService } from 'src/app/_services/chat.service';
import { Profile, ProfileService } from 'src/app/_services/profiles.service';
import { DATE_FNS_LOCALE } from 'src/app/app.module';
import { MaterialPage } from 'src/app/components/page/material-page.component';
import { environment } from 'src/environments/environment';
import { SidenavService } from 'src/app/_services/sidenav.service';

@Component({
  templateUrl: './listing-chats-page.component.html',
  styleUrls: ['./listing-chats-page.component.scss']
})
export class ListingChatsPageComponent extends MaterialPage {
  
  chats: Chat[] | undefined;
  itemToSellId: number | undefined;
  columnsToDisplay = ['author', 'lastMessage'];
  profile: Profile | undefined;
  picturesUrl = environment.picturesUrl;
  
  constructor(
    breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private profileService: ProfileService,
    readonly router: Router,
    private chatService: ChatService,
    titleService: Title,
    meta: Meta,
    sidenavService: SidenavService,
    @Inject(LOCALE_ID) private locale: string,
    @Inject(DATE_FNS_LOCALE) private dateFnsLocale: Locale) {
      
    super(breakpointObserver, titleService, meta, sidenavService, router, $localize `:page title:Listing conversations`, '', true);
  }
  
  async ngOnInit() {
    
    const routeParams = this.route.snapshot.paramMap;
    const itemIdFromRoute = Number(routeParams.get('itemId'));
    this.itemToSellId = itemIdFromRoute;
    
    const [profiles, chats] = await Promise.all([
      this.profileService.list(), 
      this.chatService.listChats(this.itemToSellId)]);
    
    this.profile = profiles[0];
    this.chats = chats;
  }
  
  getChatCorrespondent(chat: Chat): string {
    
    if (chat.authorUsername === this.profile!.username) {
      return chat.itemToSell.ownerNickName!;
    } else {
      return chat.authorUsername;
    }
  }
  
  getHumanReadableMessageTimestamp(date: Date): string {
    return formatDistanceToNow(date, { addSuffix: true, locale: this.dateFnsLocale });
  }
  
  toEdit(item: ItemToSell) {
    this.router.navigate(['/edit-listing/' + item.id]);
  }
  
  getItemURL(item: ItemToSell): string {
    return `${environment['baseURL']}/${this.locale}/view-listing/${item.id}`;
  }
  
  isCurrentUserAuthorOfMessage(message: ChatMessage): boolean {
    return message.authorUsername === this.profile?.username;
  }
  
  private getChatAuthor(chat: Chat): string {
    return chat.authorUsername || $localize `Buyer`;
  }
  
  getWhoWritesToWhomHumanReadable(chat: Chat): string {
    
    if (chat.lastMessage?.authorUsername === this.profile?.username) {
      return "Me to " + this.getChatAuthor(chat);
    } else {
      return this.getChatAuthor(chat) + " to me";
    }
  }
}
